// «Promos del kit (N) · Ver» en el resumen: abre el selector del kit (sin preselección) en un modal.
import { useState } from 'react';
import { Sparkles } from 'lucide-react';
import type { GiftSlotContext } from '@/domains/sales/wizard/steps/BuildSaleStep';
import { Button, Modal } from '@/kit';
import { useAnchorSaleContext } from '../hooks/useAnchorSaleContext';
import { SalePromotionPicker, usePhonePromotions } from './SalePromotionPicker';

export interface KitPromotionsButtonProps extends GiftSlotContext {
    sessionId: string;
}

export function KitPromotionsButton({ sessionId, ...context }: KitPromotionsButtonProps) {
    const [open, setOpen] = useState(false);
    const { withoutSureKeep } = useAnchorSaleContext(sessionId, context.anchorLine);
    const { promos } = usePhonePromotions(sessionId, withoutSureKeep, context.anchorLine);
    if (promos.length === 0) return null;
    return (
        <>
            <Button
                variant="outline"
                className="w-full justify-between border-success/40 bg-success-soft text-success hover:bg-success-soft hover:opacity-90"
                onClick={() => {
                    setOpen(true);
                }}
            >
                <span className="flex items-center gap-1.5">
                    <Sparkles className="size-4" aria-hidden />
                    Promos del kit
                    <span className="font-normal opacity-80">({promos.length})</span>
                </span>
                <span>Ver</span>
            </Button>
            <Modal
                isOpen={open}
                onClose={() => {
                    setOpen(false);
                }}
                title="Promos del kit"
                size="lg"
            >
                {open && <SalePromotionPicker sessionId={sessionId} {...context} />}
            </Modal>
        </>
    );
}
